import { LoginForm } from "@/components/forms/login-form";
import AuthLayout from "@/layouts/auth_layout";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const { t } = useTranslation();
  return (
    <AuthLayout
      headingInContent
      title={t("auth.login_title")}
      description={t("auth.login_description")}
    >
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
